import { TransferMethodDictionaryItem } from '@/models/dictionary/transferMethod';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { ITransferMethodDictionaryApi } from '@/types/dictionary';

export const useTransferMethodDictionary = defineStore('transferMethodDictionary', () => {
    const itemsAll = shallowRef<TransferMethodDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(itemsAll);

    function setData(data: ITransferMethodDictionaryApi[]) {
        itemsAll.value = data.map((item) => new TransferMethodDictionaryItem(item));
    }

    const items = computed(() => itemsAll.value);

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
